const e = "{{currentTime}} sur {{duration}}", t = "Rechercher les résultats dans {{current}} de {{total}}", n = "Aucun résultat trouvé", s = "{{count}} résultat trouvé", o = "{{count}} résultats trouvés", c = 'Lecture de $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) et $t(SECONDS, { "count": {{seconds}} }).', r = 'Lecture de $t(MINUTES, { "count": {{minutes}} }) et $t(SECONDS, { "count": {{seconds}} }).', A = 'Lecture de $t(SECONDS, { "count": {{seconds}} }).', E = "Erreur lors de l’enregistrement des modifications de la transcription.", u = "Ligne de transcription à {{time}}. Le contenu est : {{text}}.", i = 'Contenant de lignes de transcription. Il y a $t(TRANSCRIPT_LINES, { "count": {{count}} }) à l’intérieur du contenant. Pour naviguer à l’intérieur de ce conteneur, utilisez la touche directionnelle vers le bas.', T = "Enregistrement des modifications…", _ = "Modifications enregistrées à la transcription.", a = "Le bouton de mise à jour des légendes est maintenant disponible.", S = "Action", R = "Ajouter une annotation à {{time}}", l = "Ajouter une question à {{time}}", N = "Annotations", I = "Auto", O = "Auto ({{quality}})", d = "Retour", C = "Légende", P = "Langue de la légende", L = "Gérer les légendes", U = "Supprimer {{language}}", D = "Taille de police", M = "Langue de la légende : {{language}}", m = "{{language}} (automatique)", p = "Effacer la recherche", g = "Fermer", h = "Commentaires", G = "Continuer", Y = "Diminuer la vitesse de lecture", v = "Diminuer le volume par {{percent}}%", V = "Flèche bas", H = "Fermer l’éditeur de transcription", B = "Mettre à jour les légendes", F = "Erreur!", K = "Enregistrement en cours…", f = "Enregistré!", Q = "Modifier la transcription", b = "Le texte ne peut pas être vide!", W = "Plein écran", $ = "{{count}} heure", q = "{{count}} heures", x = "Augmenter la vitesse de lecture", j = "Augmenter le volume par {{percent}}%", J = "Inverser les couleurs", z = "Sauter à un pourcentage spécifique (1-10 %, 2-20 %, etc.)", y = "Sauter au démarrage", Z = "Actions pour {{title}}", X = "Raccourcis clavier", k = "Langue", w = "Flèche gauche", ee = "Menu principal", te = "{{count}} minute", ne = "{{count}} minutes", se = "Silencieux", oe = "Mode silencieux", ce = "Langue de la prochaine légende", re = "Prochain résultat de recherche", Ae = "Désactiver", Ee = "Sur le dessus", ue = "Annotation ouverte à {{time}}", ie = "Ouvrez le questionnaire achevé à {{time}}", Te = "Questionnaire ouvert à {{time}}", _e = "Mettre en pause", ae = "Lecture", Se = "Vitesse de lecture", Re = "Vitesse de lecture : {{speed}}x", le = "Langue de la légende précédente", Ne = "Précédent résultat de recherche", Ie = "Qualité", Oe = "Menu Qualité", de = "Rejouer", Ce = "Réinitialisation de la vitesse de lecture", Pe = "Flèche droite", Le = "Rechercher dans la transcription", Ue = "{{count}} seconde", De = "{{count}} secondes", Me = "Cherchez à revenir en arrière : {{seconds}} secondes", me = "Cherchez à avancer : {{seconds}} secondes", pe = "Paramètres", ge = "Raccourci", he = "Détails du support et outils", Ge = "Espace", Ye = "Menu de la vitesse de lecture", ve = "Débuter le déroulement automatique", Ve = "Activer/désactiver les légendes", He = "Basculer en sourdine", Be = "Basculer entre la lecture et la pause", Fe = "est {{count}} ligne de transcription", Ke = "sont {{count}} lignes de transcription", fe = "Chargement de la transcription...", Qe = "Impossible de charger la transscription.", be = "Options de transcription", We = "Réessayer", $e = "Transcription non disponible", qe = "Flèche vers le haut", xe = "Paramètres vidéo", je = "Volume", Je = "Volume : {{volume}}%", ze = {
  A11Y_DURATION: e,
  A11Y_SEARCH_HITS: t,
  A11Y_SEARCH_NO_RESULTS: n,
  A11Y_SEARCH_RESULTS_FOUND: s,
  A11Y_SEARCH_RESULTS_FOUND_other: o,
  A11Y_TIMESTAMP_JUMP_HOURS: c,
  A11Y_TIMESTAMP_JUMP_MINUTES: r,
  A11Y_TIMESTAMP_JUMP_SECONDS: A,
  A11Y_TRANSCRIPT_ERROR: E,
  A11Y_TRANSCRIPT_LINE: u,
  A11Y_TRANSCRIPT_LINES: i,
  A11Y_TRANSCRIPT_SAVING: T,
  A11Y_TRANSCRIPT_SUCCESS: _,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: a,
  ACTION: S,
  ADD_ANNOTATION_AT: R,
  ADD_QUESTION_AT: l,
  ANNOTATIONS: N,
  AUTO: I,
  AUTO_QUALITY: O,
  BACK: d,
  CAPTIONS: C,
  CAPTIONS_LANGUAGE: P,
  CAPTIONS_MANAGE: L,
  CAPTION_DELETE: U,
  CAPTION_FONT_SIZE: D,
  CAPTION_LANGUAGE: M,
  CAPTION_LANGUAGE_AUTOMATIC: m,
  CLEAR_SEARCH: p,
  CLOSE: g,
  COMMENTS: h,
  CONTINUE: G,
  DECREASE_PLAYBACK_SPEED: Y,
  DECREASE_VOLUME: v,
  DOWN_ARROW: V,
  EDIT_CLOSE: H,
  EDIT_CONFIRM: B,
  EDIT_ERROR: F,
  EDIT_SAVING: K,
  EDIT_SUCCESS: f,
  EDIT_TRANSCRIPT: Q,
  EDIT_VALIDATION_ERROR: b,
  FULLSCREEN: W,
  HOURS: $,
  HOURS_other: q,
  INCREASE_PLAYBACK_SPEED: x,
  INCREASE_VOLUME: j,
  INVERT_COLORS: J,
  JUMP_TO_PERCENTAGE: z,
  JUMP_TO_START: y,
  KEBAB_MENU: Z,
  KEYBOARD_SHORTCUTS: X,
  LANGUAGE: k,
  LEFT_ARROW: w,
  MAIN_MENU: ee,
  MINUTES: te,
  MINUTES_other: ne,
  MUTE: se,
  MUTED: oe,
  NEXT_CAPTION_LANGUAGE: ce,
  NEXT_HIT: re,
  OFF: Ae,
  ON_TOP: Ee,
  OPEN_ANNOTATION_AT: ue,
  OPEN_COMPLETED_QUIZ_AT: ie,
  OPEN_QUIZ_AT: Te,
  PAUSE: _e,
  PLAY: ae,
  PLAYBACK_SPEED: Se,
  PLAYBACK_SPEED_MESSAGE: Re,
  PREVIOUS_CAPTION_LANGUAGE: le,
  PREVIOUS_HIT: Ne,
  QUALITY: Ie,
  QUALITY_MENU: Oe,
  REPLAY: de,
  RESET_PLAYBACK_SPEED: Ce,
  RIGHT_ARROW: Pe,
  SEARCH_TRANSCRIPT_PLACEHOLDER: Le,
  SECONDS: Ue,
  SECONDS_other: De,
  SEEK_BACKWARD: Me,
  SEEK_FORWARD: me,
  SETTINGS: pe,
  SHORTCUT: ge,
  SIDEBAR: he,
  SPACE: Ge,
  SPEED_MENU: Ye,
  START_AUTOSCROLL: ve,
  TOGGLE_CAPTIONS: Ve,
  TOGGLE_MUTED: He,
  TOGGLE_PLAY_PAUSE: Be,
  TRANSCRIPT_LINES: Fe,
  TRANSCRIPT_LINES_other: Ke,
  TRANSCRIPT_LOADING: fe,
  TRANSCRIPT_LOAD_ERROR: Qe,
  TRANSCRIPT_OPTIONS: be,
  TRANSCRIPT_RETRY: We,
  TRANSCRIPT_UNAVAILABLE: $e,
  UP_ARROW: qe,
  VIDEO_SETTINGS: xe,
  VOLUME: je,
  VOLUME_VALUE: Je
};
export {
  e as A11Y_DURATION,
  t as A11Y_SEARCH_HITS,
  n as A11Y_SEARCH_NO_RESULTS,
  s as A11Y_SEARCH_RESULTS_FOUND,
  o as A11Y_SEARCH_RESULTS_FOUND_other,
  c as A11Y_TIMESTAMP_JUMP_HOURS,
  r as A11Y_TIMESTAMP_JUMP_MINUTES,
  A as A11Y_TIMESTAMP_JUMP_SECONDS,
  E as A11Y_TRANSCRIPT_ERROR,
  u as A11Y_TRANSCRIPT_LINE,
  i as A11Y_TRANSCRIPT_LINES,
  T as A11Y_TRANSCRIPT_SAVING,
  _ as A11Y_TRANSCRIPT_SUCCESS,
  a as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  S as ACTION,
  R as ADD_ANNOTATION_AT,
  l as ADD_QUESTION_AT,
  N as ANNOTATIONS,
  I as AUTO,
  O as AUTO_QUALITY,
  d as BACK,
  C as CAPTIONS,
  P as CAPTIONS_LANGUAGE,
  L as CAPTIONS_MANAGE,
  U as CAPTION_DELETE,
  D as CAPTION_FONT_SIZE,
  M as CAPTION_LANGUAGE,
  m as CAPTION_LANGUAGE_AUTOMATIC,
  p as CLEAR_SEARCH,
  g as CLOSE,
  h as COMMENTS,
  G as CONTINUE,
  Y as DECREASE_PLAYBACK_SPEED,
  v as DECREASE_VOLUME,
  V as DOWN_ARROW,
  H as EDIT_CLOSE,
  B as EDIT_CONFIRM,
  F as EDIT_ERROR,
  K as EDIT_SAVING,
  f as EDIT_SUCCESS,
  Q as EDIT_TRANSCRIPT,
  b as EDIT_VALIDATION_ERROR,
  W as FULLSCREEN,
  $ as HOURS,
  q as HOURS_other,
  x as INCREASE_PLAYBACK_SPEED,
  j as INCREASE_VOLUME,
  J as INVERT_COLORS,
  z as JUMP_TO_PERCENTAGE,
  y as JUMP_TO_START,
  Z as KEBAB_MENU,
  X as KEYBOARD_SHORTCUTS,
  k as LANGUAGE,
  w as LEFT_ARROW,
  ee as MAIN_MENU,
  te as MINUTES,
  ne as MINUTES_other,
  se as MUTE,
  oe as MUTED,
  ce as NEXT_CAPTION_LANGUAGE,
  re as NEXT_HIT,
  Ae as OFF,
  Ee as ON_TOP,
  ue as OPEN_ANNOTATION_AT,
  ie as OPEN_COMPLETED_QUIZ_AT,
  Te as OPEN_QUIZ_AT,
  _e as PAUSE,
  ae as PLAY,
  Se as PLAYBACK_SPEED,
  Re as PLAYBACK_SPEED_MESSAGE,
  le as PREVIOUS_CAPTION_LANGUAGE,
  Ne as PREVIOUS_HIT,
  Ie as QUALITY,
  Oe as QUALITY_MENU,
  de as REPLAY,
  Ce as RESET_PLAYBACK_SPEED,
  Pe as RIGHT_ARROW,
  Le as SEARCH_TRANSCRIPT_PLACEHOLDER,
  Ue as SECONDS,
  De as SECONDS_other,
  Me as SEEK_BACKWARD,
  me as SEEK_FORWARD,
  pe as SETTINGS,
  ge as SHORTCUT,
  he as SIDEBAR,
  Ge as SPACE,
  Ye as SPEED_MENU,
  ve as START_AUTOSCROLL,
  Ve as TOGGLE_CAPTIONS,
  He as TOGGLE_MUTED,
  Be as TOGGLE_PLAY_PAUSE,
  Fe as TRANSCRIPT_LINES,
  Ke as TRANSCRIPT_LINES_other,
  fe as TRANSCRIPT_LOADING,
  Qe as TRANSCRIPT_LOAD_ERROR,
  be as TRANSCRIPT_OPTIONS,
  We as TRANSCRIPT_RETRY,
  $e as TRANSCRIPT_UNAVAILABLE,
  qe as UP_ARROW,
  xe as VIDEO_SETTINGS,
  je as VOLUME,
  Je as VOLUME_VALUE,
  ze as default
};
